import { render, staticRenderFns } from "./UretimStokOzelKod2CellRenderer.vue?vue&type=template&id=2d7fe0b2"
import script from "./UretimStokOzelKod2CellRenderer.vue?vue&type=script&lang=js"
export * from "./UretimStokOzelKod2CellRenderer.vue?vue&type=script&lang=js"
import style0 from "./UretimStokOzelKod2CellRenderer.vue?vue&type=style&index=0&id=2d7fe0b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports